import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { ProcessingSession } from "./processing-session";

export const getProcessingSession = {
  name: "getProcessingSession" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ session: ProcessingSession.nullable() }),
};
